import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("aru_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function getToken() {
  return localStorage.getItem("aru_token");
}

export function fileDownloadUrl(fileId) {
  return `${API}/files/${fileId}/download?auth=${getToken()}`;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
